var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _polygon, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgviewerGoogleLogoNewMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3959,8.8345l-.0039.0038c.0837.2319.1617.4667.2285.7062C25.5527,9.3047,25.48,9.067,25.3959,8.8345Z",
    fill: "#4285f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2.23,8.929,5.1593,12.9916,9.222A4.2486,4.2486,0,0,1,19.0208,15.21L25,9.23l.392-.392A9.9872,9.9872,0,0,0,16,2.23Z",
    fill: "#4285f4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16,16.4733A4.25,4.25,0,0,1,12.9916,9.222L8.929,5.1593A9.9683,9.9683,0,0,0,6,12.23c0,4.4057,2.2651,7.1668,4.93,10,.1787.1828.3274.3852.4959.5746l7.5608-7.5609A4.2341,4.2341,0,0,1,16,16.4733Z",
    fill: "#ffba00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2.23a10,10,0,0,0-10,10,11.0918,11.0918,0,0,0,.5454,3.4546l12.8505-12.85A9.9563,9.9563,0,0,0,16,2.23Z",
    fill: "#0066da"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9011,29.12a21.83,21.83,0,0,1,4.032-6.8966C23.7976,19.3129,26,16.636,26,12.23a9.9585,9.9585,0,0,0-.6041-3.3958l-13.97,13.97A18.0436,18.0436,0,0,1,15.0173,29.08.9975.9975,0,0,0,16.9011,29.12Z",
    fill: "#00ac47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.93,22.23c.1787.1828.3274.3852.4959.5746h0C11.257,22.6155,11.1083,22.4131,10.93,22.23Z",
    fill: "#0066da",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.207,7.4637A9.9357,9.9357,0,0,0,6.45,9.2566,9.9429,9.9429,0,0,1,7.207,7.4637Z",
    fill: "#0066da",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45,9.2566a9.9522,9.9522,0,0,0-.398,1.9513A9.9537,9.9537,0,0,1,6.45,9.2566Z",
    fill: "#0066da",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1957,29.3989c.02.0248.0445.0422.0664.0644C15.24,29.4411,15.2156,29.4236,15.1957,29.3989Z",
    fill: "#ffffff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7874,29.7429l.04.0066Z",
    fill: "#ffffff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6216,25.9269c-.0371-.067-.0679-.1382-.1059-.2047C13.5533,25.789,13.5849,25.86,13.6216,25.9269Z",
    fill: "#ffffff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0173,29.08q-.3069-.9036-.6906-1.7566C14.5793,27.8937,14.8127,28.4771,15.0173,29.08Z",
    fill: "#ffffff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5269,29.6563c-.0229-.0112-.0463-.0207-.0684-.0338C15.4809,29.6356,15.5036,29.6452,15.5269,29.6563Z",
    fill: "#ffffff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7117,23.7529c-.249.3474-.4679.7125-.6927,1.0741C19.2431,24.465,19.4633,24.1006,19.7117,23.7529Z",
    fill: "#ffffff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "23.322 19.553 23.322 19.553 23.322 19.553 23.322 19.553"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0468,28.774h0q.3516-.887.7561-1.7428C17.5316,27.6006,17.2812,28.1826,17.0468,28.774Z",
    fill: "#ffffff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.68,25.3584c-.2879.4957-.55,1.0068-.8,1.5242C18.13,26.3647,18.3931,25.8547,18.68,25.3584Z",
    fill: "#ffffff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.929,5.1593A9.9683,9.9683,0,0,0,6,12.23a11.0918,11.0918,0,0,0,.5454,3.4546L13,9.23Z",
    fill: "#ea4435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgviewerGoogleLogoNewMaps);
export default __webpack_public_path__ + "static/media/svgviewer-Google Logo New Maps.dba31cb9857d5df17ebe90595516d38b.svg";
export { ForwardRef as ReactComponent };